// extracted by mini-css-extract-plugin
export default {"grid":"ImageBlock-module--grid--b6b19","container":"ImageBlock-module--container--033e9","attribution":"ImageBlock-module--attribution--24d2e"};